import {
  Box,
  Container,
  Divider,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BeneficiaryDetailCard from './Component/BeneficiaryDetailCard';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const BeneficiaryDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const SpecificBeneficiary = location.state?.beneficiary;
  const isNominee = location.state?.isNominee;
  const scrollTo = location.state?.scrollTo;
  const NomineeIndex = location.state?.NomineeIndex;

  return (
    <>
      <Container
        maxWidth='true'
        sx={{
          pl: '2rem',
          pt: '5rem',
          height: window.innerHeight,
          overflowY: 'auto',
        }}
      >
        <Box>
          <Stack
            spacing={2}
            direction='row'
          >
            <IconButton
              aria-label='Screenback'
              sx={{ color: 'black' }}
              onClick={() => navigate(-1)}
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography variant='h4'>Edit Details</Typography>
          </Stack>
        </Box>
        <Divider sx={{ mt: '1rem', mb: '3rem' }} />
        <BeneficiaryDetailCard
          data={SpecificBeneficiary}
          isNominee={isNominee}
          scroll={scrollTo}
          NomineeIndex={NomineeIndex}
        />
      </Container>
    </>
  );
};

export default BeneficiaryDetails;
